<template>
  <UserTable />
</template>

<script>
import UserTable from '@/components/user/UserTable'

export default {
  name: 'UserView',
  components: {UserTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
